import { ExportColumnDef } from "./export-column-def";

export enum ExportType {
    Pdf = 0,
    Excel = 1,
    Csv = 2,       
}

export class ExportConfigModel {
    reportTitle?: string;
    reportSubTitle?: string;
    fileName?: string;
    isLandScape: boolean = false;
    exportType?: ExportType;
    exportColumnDefinitions: Array<ExportColumnDef> = new Array();
    searchModel: any;
}
